import React, { useState, useEffect, useRef } from 'react'
import './RestrictedDia.css';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { QRCodeCanvas } from 'qrcode.react';
import { restrictedApply, restrictedCheck } from '../../../api/em';
// import YunIcon from '../YunIcon/YunIcon';

const RestrictedDia = function({ isOpen, onClose, onSuccess }) {
    const [qrUrl, setQrUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    // 轮询句柄与激活标志，用于安全中止
    const pollTimerRef = useRef(null);
    const activeRef = useRef(false);
    // 二维码过期计时
    const expireTimerRef = useRef(null);
    const [expired, setExpired] = useState(false);

    useEffect(() => {
        if (isOpen) {
            loadQrcode();
        } else {
            stopPolling();
        }
        return () => {
            stopPolling();
            clearExpireTimer();
        };
        // 仅在 isOpen 切换时触发；loadQrcode 每次渲染重建，不应作为依赖，否则会不断重新取码
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    const stopPolling = () => {
        activeRef.current = false;
        if (pollTimerRef.current) {
            clearTimeout(pollTimerRef.current);
            pollTimerRef.current = null;
        }
    };

    const clearExpireTimer = () => {
        if (expireTimerRef.current) {
            clearTimeout(expireTimerRef.current);
            expireTimerRef.current = null;
        }
    };

    // 二维码生成后启动 180s 过期计时，到期覆盖蒙版并停止轮询
    const startExpireTimer = () => {
        clearExpireTimer();
        setExpired(false);
        expireTimerRef.current = setTimeout(() => {
            setExpired(true);
            stopPolling();
        }, 180000);
    };

    const startPolling = () => {
        activeRef.current = true;
        const tick = async () => {
            if (!activeRef.current) return;
            try {
                const result = await restrictedCheck();
                if (!activeRef.current) return;
                if (result && result.err === 'ERR_OK' && result.restrict && !result.restrict.restricted) {
                    stopPolling();
                    if (onSuccess) {
                        onSuccess();
                    }
                    handleClose();
                    return;
                }
            } catch (error) {
                // 瞬时错误，继续轮询
            }
            if (!activeRef.current) return;
            pollTimerRef.current = setTimeout(tick, 3000);
        };
        pollTimerRef.current = setTimeout(tick, 3000);
    };

    const loadQrcode = async () => {
        stopPolling();
        clearExpireTimer();
        setExpired(false);
        setLoading(true);
        setErrorMsg('');
        try {
            const result = await restrictedApply();
            if (result && result.err === 'ERR_OK' && result.restrict && result.restrict.liftUrl && result.restrict.tid) {
                setQrUrl(result.restrict.liftUrl);
                startPolling();
                startExpireTimer();
            } else {
                setErrorMsg(result.errMsg || '获取二维码失败');
            }
        } catch (error) {
            setErrorMsg('获取二维码失败，请重试');
        } finally {
            setLoading(false);
        }
    };

    const handleRefresh = () => {
        loadQrcode();
    };

    const handleClose = () => {
        stopPolling();
        clearExpireTimer();
        setExpired(false);
        setQrUrl('');
        setErrorMsg('');
        if (onClose) {
            onClose();
        }
    };

    return (
        <Dialog
            open={isOpen}
            className="RestrictedDia"
            onClose={(event, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    return;
                }
                handleClose();
            }}
        >
            {/* <YunIcon icon="close" iconClass="RestrictedDiaClose" onClick={handleClose} /> */}
            <DialogTitle>人机验证</DialogTitle>
            <DialogContent>
                <div className="WafCaptchaContent">
                    <div style={{ marginBottom: '5px', fontSize: '11px', textAlign: 'center', lineHeight: '1.3' }}>
                        请扫码完成验证
                    </div>
                    {loading ? (
                        <div className="WafCaptchaLoading">加载中...</div>
                    ) : qrUrl ? (
                        <div className="RestrictedQr" onClick={handleRefresh} title="点击刷新">
                            <QRCodeCanvas value={qrUrl} size={148}  />
                            {expired && (
                                <div className="RestrictedQrMask">
                                    <span>二维码已过期</span>
                                    <span>点击刷新</span>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="WafCaptchaLoading" onClick={handleRefresh}>点击刷新获取</div>
                    )}
                    {
                        expired && (
                            <div className="WafCaptchaTip">
                                点击二维码刷新
                            </div>
                        )
                    }
                    <div className="WafCaptchaError">
                        {errorMsg}
                    </div>
                </div>
            </DialogContent>
            {/* <DialogActions>
                <div
                    onClick={handleRefresh}
                    className="WafCaptchaBtn primary"
                >
                    刷新
                </div>
            </DialogActions> */}
        </Dialog>
    )
}

export default RestrictedDia;
